import { types } from "../../actions"

export default function collectionReleaseReducer(state, action) {
  switch (action.type) {
    case types.release:
      return {
        ...state,
        involved: state.involved - 1,
      }
    case types.involve:
      return {
        ...state,
        involved: state.involved + 1,
      }
    default:
      return state
  }
}
